import CurrentAiChat from "../current-ai-chat";
import FormManager from "../../../../../core/gd-form/common/form-manager";

export default function aiChat_initChatMessageForm(): FormManager {

    const formStructure = {
        isFormChanged   : true,
        fields          : {
            message         : {
                type            : 'input',
                isRequired      : false,
            },
            messageRTF      : {
                type            : 'input',
                isRequired      : false,
                validator       : (value : any, formManager: FormManager)=> {

                    const noText: boolean       = !formManager.getValue('message').trim()
                    const hasImageEntity: any   = value && value.entityMap && _.find(_.values(value.entityMap), e=>e.type === "IMAGE")

                    // if (isRequired && noText && !hasImagexEntity) {
                    if (noText && !hasImageEntity) {
                        return "Message is required"
                    }
                    return true
                }
            },
        }
    }

    const initFormData = {
        message     : "",
        messageRTF  : null,
    }

    return new FormManager(formStructure, initFormData)
}
